import React, { useState, useEffect } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import api from '../../api';

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const UserPresenceMap = () => {
  const [markers, setMarkers] = useState([]);

  const token =
    localStorage.getItem("access_token") || sessionStorage.getItem("access_token");

  useEffect(() => {
    const fetchPresence = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/auth/user-presence`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const users = response.data.users || [];
        const activeMarkers = [];

        users.forEach((user) => {
          user.active_sessions.forEach((session) => {
            if (session.latitude && session.longitude) {
              activeMarkers.push({
                name: user.name,
                coordinates: [session.longitude, session.latitude],
              });
            }
          });
        });

        setMarkers(activeMarkers);
      } catch (err) {
        console.error("Failed to fetch user presence:", err);
      }
    };

    fetchPresence();
  }, [token]);

  return (
    <div
      style={{
        // background: "#fff",
        borderRadius: "12px",
        padding: "5px",
        overflow: "hidden",
      }}
    >
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "30px" }}
      >
        {/* <div
          style={{
            height: "34px",
            width: "4px",
            backgroundColor: "#2b2b2b",
            marginRight: "10px",
            borderRadius: "2px",
          }}
          
        />
        <h3 style={{ fontSize: "26px", fontWeight: 600, margin: 0 }} className="refresh-prompts">
          User Presences
        </h3> */}
          <span className="border-start border-4 ps-2 refresh-prompts">
          User Presences
        </span>
      </div>

      <div style={{ height: "320px" }}>
        <ComposableMap
          projectionConfig={{ scale: 170, center: [0, 0] }}
          width={800}
          height={400}
          style={{ width: "100%", height: "100%" }}
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: {
                      fill: "#d3d3d3",
                      stroke: "#fff",
                      strokeWidth: 0.5,
                    },
                    hover: { fill: "#d3d3d3" },
                    pressed: { fill: "#d3d3d3" },
                  }}
                />
              ))
            }
          </Geographies>

          {markers.map(({ name, coordinates }) => (
            <Marker
              key={name + coordinates.join(",")}
              coordinates={coordinates}
            >
              <circle r={5} fill="#1c1c1c" />
            </Marker>
          ))}
        </ComposableMap>
      </div>
    </div>
  );
};

export default UserPresenceMap;
